import Vue from "vue";
import collect from "collect.js";

Object.defineProperty(Vue.prototype, 'collect', {value: collect});
